import { API_BASE_URL } from "./config";

const BASE_URL = `${API_BASE_URL}/api/dashboard`;

export interface FilterParams {
  fiscalYear?: string;
  budgetVersion?: string;
  accountCategory?: string;
  glAccount?: string;
  costCenter?: string;
}

function buildQuery(params: FilterParams): string {
  const q = new URLSearchParams();
  if (params.fiscalYear)      q.set("fiscalYear",      params.fiscalYear);
  if (params.budgetVersion)   q.set("budgetVersion",   params.budgetVersion);
  if (params.accountCategory) q.set("accountCategory", params.accountCategory);
  if (params.glAccount)       q.set("glAccount",       params.glAccount);
  if (params.costCenter)      q.set("costCenter",      params.costCenter);
  return q.toString() ? `?${q.toString()}` : "";
}

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`);
  if (!res.ok) throw new Error(`API error ${res.status}: ${await res.text()}`);
  return res.json();
}

export const dashboardApi = {
  getFilters:              ()                  => get<any>("/filters"),
  getHeader:               (p: FilterParams)   => get<any>(`/header${buildQuery(p)}`),
  getKpis:                 (p: FilterParams)   => get<any>(`/kpis${buildQuery(p)}`),
  getVarianceChart:        (p: FilterParams)   => get<any>(`/variance-chart${buildQuery(p)}`),
  getTrendChart:           (p: FilterParams)   => get<any>(`/trend-chart${buildQuery(p)}`),
  getInsights:             (p: FilterParams)   => get<any>(`/insights${buildQuery(p)}`),
  getApprovals:            (p: FilterParams)   => get<any>(`/approvals${buildQuery(p)}`),
  getVarianceExplorer:     (p: FilterParams)   => get<any>(`/variance-explorer${buildQuery(p)}`),
  getFinancialIntelligence:(p: FilterParams)   => get<any>(`/financial-intelligence${buildQuery(p)}`),
  getExecutiveSummary:     (p: FilterParams)   => get<any>(`/executive-summary${buildQuery(p)}`),
  getAudit:                ()                  => get<any>(`/audit`),
  getVePostings:           (fiscalYear: string, accountName: string, costCenter?: string) =>
    get<any>(`/ve-postings?fiscalYear=${encodeURIComponent(fiscalYear)}&accountName=${encodeURIComponent(accountName)}${costCenter ? `&costCenter=${encodeURIComponent(costCenter)}` : ""}`),
  getVeCostCenters:        (fiscalYear: string, accountName: string, costCenter?: string) =>
    get<any>(`/ve-cost-centers?fiscalYear=${encodeURIComponent(fiscalYear)}&accountName=${encodeURIComponent(accountName)}${costCenter ? `&costCenter=${encodeURIComponent(costCenter)}` : ""}`),
  getMonthlyTrends:        (p: FilterParams) => get<any>(`/monthly-trends${buildQuery(p)}`),
};
